interface Props {
  shouldDoubleOpt: boolean;
  signupFlowId?: string;
  automationIds?: string;
  autoLoginEnabled?: boolean;
}

const ServerSideInputs = ({ shouldDoubleOpt, signupFlowId, automationIds, autoLoginEnabled }: Props) => {
  return (
    <>
      <input name="sent_from_orchid" type="hidden" value="true" />
      <input name="signup_flow_id" type="hidden" value={signupFlowId} />
      <input name="automation_ids" type="hidden" value={automationIds} />
      <input name="double_opt" type="hidden" value={shouldDoubleOpt?.toString()} />
      <input name="auto_login_enabled" type="hidden" value={autoLoginEnabled ? 'true' : 'false'} />
    </>
  );
};

export default ServerSideInputs;
